import { Component } from '@angular/core';

@Component({
  selector: 'app-actual-arrival-editable',
  template: `
  <div style="margin: 3px 0px 6px;">
    <input #input [(ngModel)]="value" type="number" class="grid-cell-edit-layout " (change)="textUpdated()" (keydown)="onKeyPress($event)" (wheel)="checknegativevalue($event)" />
    <small *ngIf="!value && params.data.eta_date && (!checkKeyInObject('isArrived') || (checkKeyInObject('isArrived') && !params.data.isArrived)) && params.context.componentParent.submitted" class="error">In case of ETA conf lots is required</small>
    <small *ngIf="!value && checkKeyInObject('isArrived') && params.data.isArrived  && params.context.componentParent.submitted" class="error">In case of Arrived conf lots is required</small>
  </div>
  `,
  styles: [
    `
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      .grid-cell-edit-layout {
        width: 100%;
        border: 1px solid #d1d1d1;
      }
      .invalid-text {
        border: 2px solid red !important;
      }
      .error{color:red}
    `,
  ],
})
export class ConfLotsEditableComponent {
  public params: any;
  showInput = true;
  value: any;
  isEmpty = true;

  lastDayOfVanMonth = localStorage.getItem('lastDayOfVanMonth');

  constructor() { }

  agInit(params: any): void {
    params.data.configureLots = this;
    if (params.column === 'conf_lots') {
      this.value = params.data.conf_lots;
    }

    this.params = params;
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  textUpdated() {
    if (this.params.column === 'conf_lots') {
      if (this.value !== this.params.data.conf_lots) {
        this.params.data.conf_lots = this.value;
        this.params.data.isUpdated = true;
      }
    }
  }

  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);

    // Access the input element
    const inputElement = event.target as HTMLInputElement;

    // Check if the current value plus the new key would exceed the max length
    const currentValue = inputElement.value;
    if (currentValue.length >= 5 && isNumber) {
      event.preventDefault(); // Prevent input if max length is reached
      return;
    }

    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  checknegativevalue(event: WheelEvent) {
    event.preventDefault();
  }
  checkKeyInObject(key: string): boolean {
    return this.params.data.hasOwnProperty(key);
  }
}
